export default [
	{
		name: 'thirdparties-integrations',
		path: '/integrations/thirdparties/:thirdPartyId/integrations',
		props: route => ({
			thirdPartyId: parseInt(route.params.thirdPartyId),
			search: route.query.search || '',
			customerId: route.query.customerId || null,
			status: route.query.status || 'all',
			integrationId: route.query.integrationId,
			count: parseInt(route.query.count)
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/integration/integrations/integrations-page.vue'
			),
		meta: {
			permissions: ['integration.read']
		}
	}
];
